import { Forbidden } from "@/pages";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { Navigate, useLocation, useMatches } from "react-router-dom";
import { useAuth } from ".";
import { CenteredLoading } from "../ui";

export const RequireAuth = ({ children }) => {
  let {
    user,
    outlet,
    isLoading,
    fetchUserPayload,
    fetchOutlet,
    hasPermission,
  } = useAuth();
  const location = useLocation();
  const matches = useMatches();

  const requiredPermission = matches[matches.length - 1].handle?.permission;

  useEffect(() => {
    if (!user) fetchUserPayload();
    if (!outlet) fetchOutlet();
  }, [fetchOutlet, fetchUserPayload, outlet, user]);

  if (isLoading) {
    return <CenteredLoading sx={{ height: "100vh" }} />;
  } else if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Forbidden />;
  }

  return children;
};

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired,
};
